import type { TOC } from '@ember/component/template-only'

interface Args {
  class: string
}

interface Signature {
  Args: Args
  Element: HTMLDivElement
  Blocks: {
    default: unknown[]
  }
}

export const ManageActionsDiv: TOC<Signature> = <template>
  <div class={{@class}} ...attributes>{{yield}}</div>
</template>

export default ManageActionsDiv
